import ArrowDownward from '@mui/icons-material/ArrowDownward';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { ValuePlaceholder } from '../Value/ValuePlaceholder/ValuePlaceholder.tsx';
import { changeIndicatorSx, labelSx, metricRowSx, metricValueSx } from './styles.ts';

export type MetricTabChange = {
  direction: 'increase' | 'decrease';
  label: string;
};

export type MetricTabLabelProps = {
  title: string;
  value?: string | null;
  change?: MetricTabChange;
  isLoading?: boolean;
};

export const MetricTabLabel = ({ title, value, change, isLoading }: MetricTabLabelProps) => {
  const isValueAvailable = value != null;
  const isIncrease = change?.direction === 'increase';
  const ChangeIcon = isIncrease ? ArrowUpward : ArrowDownward;

  return (
    <Stack spacing={0.5} sx={labelSx}>
      <Typography variant="body1" color="textSecondary">
        {title}
      </Typography>
      {isLoading ? (
        <Skeleton
          animation="wave"
          width="70%"
          height={32}
          data-test="metric-tab-loading"
          aria-label={`Loading ${title}`}
        />
      ) : (
        <Stack direction="row" spacing={1} sx={metricRowSx}>
          {isValueAvailable ? (
            <Typography variant="h2" sx={metricValueSx}>
              {value}
            </Typography>
          ) : (
            <ValuePlaceholder dataTestParam="metric-tab-value" />
          )}
          {isValueAvailable && change ? (
            <Stack
              direction="row"
              sx={changeIndicatorSx(isIncrease)}
              aria-label={`${change.direction}: ${change.label}`}
            >
              <ChangeIcon fontSize="small" />
              <Typography variant="body1" color="inherit">
                {change.label}
              </Typography>
            </Stack>
          ) : null}
        </Stack>
      )}
    </Stack>
  );
};
